import React from 'react'
import { Container } from 'semantic-ui-react'

export default function Error404() {
  return (
    <Container>
      <div style={{ margin: '50px 0' }}>
        <h1>Oh no&apos;s! We couldn&apos;t find that page :(</h1>
      </div>
    </Container>
  )
}
